"use client";

import React, {useState} from "react";
import {Container} from "@/shared/components/shared";
import Image from "next/image";
import BottomModal from "@/shared/components/ui/modal-bottom";
import {Button} from "@/shared/components/ui/button";
import UniversalBookingModal from "@/shared/components/ui/universal-booking-modal";
import Link from "next/link";


interface CardProps {
    imageSrc: string;
    title: string;
    width?: number;
    height?: number;
    gradient: boolean;
    onCardClick?: () => void;
    isModal?: boolean;
    link: string;
}

const Card = ({imageSrc, title, width = 740, height = 298, gradient = true, onCardClick, isModal = true, link = ''}: CardProps) => {
    const handleLinkClick = () => {
        if (typeof window !== 'undefined') {
            sessionStorage.setItem('scrollPosition', window.scrollY.toString());
        }
    };

    if (!isModal && link) {
        return (
            <Link href={link} onClick={handleLinkClick}>
                <div className="relative group overflow-hidden rounded-[20px] cursor-pointer">
                    <div
                        className="w-[100%] h-[184px] lg:w-[740px] lg:h-[298px] relative flex items-center justify-center">
                        <Image
                            src={imageSrc}
                            alt="Card"
                            width={width}
                            height={height}
                            className="object-cover transition-transform duration-300 group-hover:scale-105"
                        />
                        {gradient &&
                            <div
                                className="absolute inset-0 bg-gradient-to-b from-transparent from-34% to-[rgba(40,40,40,0.91)] to-94% mix-blend-multiply"/>
                        }

                        <div
                            className="absolute inset-0 z-10 flex items-end justify-between pl-[24px] pr-[24px] pt-[21px] pb-[21px] lg:p-6">
                            <h3 className="text-white text-[24px] lg:text-[32px] uppercase leading-[1.2]"
                                dangerouslySetInnerHTML={{__html: title}}/>
                            <Image src={'/images/arrow-white-right.svg'} width={23} height={14} alt={'открыть карточку'}
                                   className={'w-[16px] h-[16px] lg:w-[23px] lg:h-[23px]'}/>
                        </div>
                    </div>
                </div>
            </Link>
        )
    }
    return (
        <div className="relative group overflow-hidden rounded-[20px] cursor-pointer" onClick={onCardClick}>
            <div className="w-[100%] h-[184px] lg:w-[740px] lg:h-[298px] relative flex items-center justify-center">
                <Image
                    src={imageSrc}
                    alt="Card"
                    width={width}
                    height={height}
                    className="object-cover transition-transform duration-300 group-hover:scale-105"
                />
                {gradient &&
                    <div
                        className="absolute inset-0 bg-gradient-to-b from-transparent from-34% to-[rgba(40,40,40,0.91)] to-94% mix-blend-multiply"/>
                }

                <div
                    className="absolute inset-0 z-10 flex items-end justify-between pl-[24px] pr-[24px] pt-[21px] pb-[21px] lg:p-6">
                    <h3 className="text-white text-[24px] lg:text-[32px] uppercase leading-[1.2]"
                        dangerouslySetInnerHTML={{__html: title}}/>
                    <Image src={'/images/arrow-white-right.svg'} width={23} height={14} alt={'открыть карточку'}
                           className={'w-[16px] h-[16px] lg:w-[23px] lg:h-[23px]'}/>
                </div>
            </div>
        </div>
    )
}


const cardsData = [
    {
        imageSrc: "/images/profitable-offers/surprise.png",
        title: "подарки новым гостям",
        gradient: true,
        isModal: true,
        link: '',
        titleModal: "Подарки новым гостям",
        descriptionModal: "",
        childrenModal: (
            <>
                <div className="mt-4 lg:mt-6 mb-4 lg:mb-6 flex items-center justify-center">
                    <Image 
                        src={'/images/profitable-offers/oil-heart.jpg'} 
                        className={'rounded-2xl w-auto h-auto max-h-[50vh] max-w-full object-contain'} 
                        width={800} 
                        height={400} 
                        alt={'подарки новым гостям'}
                    />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 lg:gap-4">
                    <div className="bg-custom-ig rounded-lg lg:rounded-2xl p-4 lg:p-6 flex items-center justify-center text-center">
                        <div>
                            <div className="text-custom-orange font-bold text-[16px] lg:text-[24px] leading-tight">Выгода 1000 р</div>
                            <div className="text-custom-black text-[16px] lg:text-[18px] mt-1 lg:mt-2 leading-tight">на "Замену масла в двигателе"</div>
                            <div className="text-custom-light-gray text-[14px] lg:text-[16px] mt-1 lg:mt-2 leading-tight">*при покупке у нас расходных материалов</div>
                        </div>
                    </div>
                    <div className="bg-custom-ig rounded-lg lg:rounded-2xl p-4 lg:p-6 flex items-center justify-center text-center">
                        <div>
                            <div className="text-custom-orange font-bold text-[16px] lg:text-[24px] leading-tight">50% СКИДКА</div>
                            <div className="text-custom-black text-[16px] lg:text-[18px] mt-1 lg:mt-2 leading-tight">на диагностику автомобиля</div>
                        </div>
                    </div>
                    <div className="bg-custom-ig rounded-lg lg:rounded-2xl p-4 lg:p-6 flex items-center justify-center text-center">
                        <div className="text-custom-black text-[16px] lg:text-[18px] leading-tight">Визуальный чек ап ходовой части</div>
                    </div>
                    <div className="bg-custom-ig rounded-lg lg:rounded-2xl p-4 lg:p-6 flex items-center justify-center text-center">
                        <div className="text-custom-black text-[16px] lg:text-[18px] leading-tight">+ Сервис бизнес-класса <span className="text-custom-orange font-bold">в подарок</span></div>
                    </div>
                </div>
            </>
        )
    },
    {
        imageSrc: "/images/profitable-offers/offers.png",
        title: "акции",
        gradient: false,
        isModal: true,
        link: '',
        titleModal: "Попробуйте новый формат сервисной книжки",
        descriptionModal: "",
        childrenModal: (
            <>
                <div className="bg-custom-ig rounded-lg lg:rounded-2xl p-4 lg:p-6 flex items-center justify-center text-center mt-4 lg:mt-6 mb-4 lg:mb-6">
                    <div className="text-custom-black text-[16px] lg:text-[18px] leading-tight">
                        Скачайте приложение <span className="text-custom-orange font-bold">ORTUS</span> и получите все услуги с <span className="text-custom-orange font-bold">выгодой 10%</span> при онлайн‑записи.
                    </div>
                </div>
                <Image src={'/images/profitable-offers/offers-ortus.png'} className={'rounded-2xl w-full h-auto lg:h-[350px] object-cover mb-6'} width={800} height={350} alt={'в приложении ortus скидка 10%'}/>
            </>
        )
    },
    {
        imageSrc: "/images/profitable-offers/lottery.png",
        title: "розыгрыши",
        gradient: true,
        isModal: true,
        link: '',
        titleModal: "Розыгрыши",
        descriptionModal: "Совсем скоро здесь начнутся регулярные сезонные розыгрыши — с практичными и приятными призами, которые пригодятся каждому владельцу автомобиля.<br/> Не пропустите старт, чтобы узнать условия первыми.<br/> А пока вы можете воспользоваться нашими действующими акциями и подарками.",
        childrenModal: <></>
    }
    // {
    //     imageSrc: "/images/profitable-offers/cars.png",
    //     title: "автофестивали",
    //     gradient: true,
    //     isModal: false,
    //     link: '/autofest',
    //     titleModal: "Подарки новым гостям",
    //     descriptionModal: "",
    //     childrenModal: <></>
    // }
];


export const ProfitableOffers: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectCard, setIsSelectCard] = useState(0);
    const [isUniversalBookingOpen, setIsUniversalBookingOpen] = useState(false);

    const openModal = (index = 0) => {
        setIsModalOpen(true)
        setIsSelectCard(index)
    }

    return (
        <>
            <section id={'promotions'}>
                <Container className={'pt-12 pb-12 lg:pt-30 lg:pb-34'}>
                    <h2 className={'text-[30px] lg:text-[70px] font-bold text-custom-black leading-[1.2] uppercase'}>
                        выгодные предложения<br/> и <span className={'text-custom-orange'}>яркие события</span>
                    </h2>
                    <div
                        className={'grid grid-cols-1 sm:grid-cols-2 gap-x-[0px] sm:gap-x-10 gap-y-[18px] sm:gap-y-8 mt-11 lg:mt-17'}>
                        {cardsData.map((card, index) => (
                            <Card key={index} imageSrc={card.imageSrc} title={card.title} gradient={card.gradient} onCardClick={() => openModal(index)} isModal={card.isModal} link={card.link}/>
                        ))}
                    </div>
                </Container>
            </section>
            <BottomModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className="w-full max-w-[800px] mx-auto">
                    {/* Фиксированный заголовок с крестиком */}
                    <div className="sticky top-0 bg-white z-20 px-6 pt-6 pb-6 border-b border-gray-100">
                        <button
                            onClick={() => setIsModalOpen(false)}
                            className="absolute top-4 right-4 cursor-pointer hover:opacity-70 transition-opacity z-10"
                            aria-label="Закрыть"
                        >
                            <svg 
                                width="40" 
                                height="40" 
                                viewBox="0 0 40 40" 
                                fill="none" 
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-6 h-6 lg:w-10 lg:h-10"
                            >
                                <path 
                                    d="M10 10L30 30M30 10L10 30" 
                                    stroke="currentColor" 
                                    strokeWidth="2" 
                                    strokeLinecap="round"
                                    className="text-custom-light-gray"
                                />
                            </svg>
                        </button>
                        <h2 className="text-[18px] lg:text-[20px] font-bold text-custom-black leading-[1.2] uppercase pr-10">{cardsData[selectCard].titleModal}</h2>
                    </div>
                    
                    {/* Прокручиваемый контент */}
                    <div className="px-6 pb-6">
                        {cardsData[selectCard].descriptionModal && (
                            <p className="text-[14px] lg:text-[16px] text-custom-dark-gray mb-6 mt-4 lg:mt-6" dangerouslySetInnerHTML={{__html: cardsData[selectCard].descriptionModal}}/>
                        )}
                        {cardsData[selectCard].childrenModal}
                        {selectCard === 0 && (
                            <div className="grid grid-cols-1 gap-3 lg:gap-4 mt-6">
                                <Button 
                                    className={'font-button w-full font-bold py-3 px-4'}
                                    onClick={() => { setIsUniversalBookingOpen(true); setIsModalOpen(false); }}
                                >
                                    записаться
                                </Button>
                                <Button 
                                    className={'font-button w-full font-bold py-3 px-4'}
                                    onClick={() => { setIsUniversalBookingOpen(true); setIsModalOpen(false); }}
                                >
                                    Узнать подробнее
                                </Button>
                            </div>
                        )}
                        {selectCard === 1 && (
                            <Button 
                                className={'font-button w-full font-bold py-3 px-4'}
                                onClick={() => { setIsUniversalBookingOpen(true); setIsModalOpen(false); }}
                            >
                                Записаться онлайн
                            </Button>
                        )}
                    </div>
                </div>
            </BottomModal>
            <UniversalBookingModal isOpen={isUniversalBookingOpen} onClose={() => setIsUniversalBookingOpen(false)} blockName="Выгодные предложения"/>
        </>
    );
}